import { tracking } from '../../tracking.js';
import { telemetryPathClass, type AuthPathClass } from '../../auth-endpoints';

export const AUTH_REFRESH_FAILED = 'Auth Refresh Failed';
export const AUTH_SESSION_RESET = 'Auth Session Reset';

export type AuthTelemetryReason = 'network' | 'http_403' | 'http_429' | 'http_5xx' | 'http_other' | 'session_dead';

export type AuthTelemetryProps = {
  pathClass?: AuthPathClass;
  httpStatus?: number;
  reason?: AuthTelemetryReason;
  latched?: boolean;
  originalCorrelationId?: string;
  refreshCorrelationId?: string;
  retryCorrelationId?: string;
};

const FORBIDDEN_KEYS = ['url', 'path', 'query', 'token', 'email', 'jti', 'refreshToken', 'accessToken'];

export function sanitizeAuthTelemetryProps(input: AuthTelemetryProps = {}): Record<string, unknown> {
  const safe: Record<string, unknown> = {};
  if (input.pathClass) {
    safe.pathClass = telemetryPathClass(input.pathClass);
  }
  if (typeof input.httpStatus === 'number') {
    safe.httpStatus = input.httpStatus;
  }
  if (input.reason) {
    safe.reason = input.reason;
  }
  if (typeof input.latched === 'boolean') {
    safe.latched = input.latched;
  }
  if (input.originalCorrelationId) {
    safe.originalCorrelationId = input.originalCorrelationId;
  }
  if (input.refreshCorrelationId) {
    safe.refreshCorrelationId = input.refreshCorrelationId;
  }
  if (input.retryCorrelationId) {
    safe.retryCorrelationId = input.retryCorrelationId;
  }
  FORBIDDEN_KEYS.forEach(key => {
    delete safe[key];
  });
  return safe;
}

function emitIsolated(eventName: string, properties: Record<string, unknown>) {
  try {
    tracking(eventName, properties, { amplitude: false });
  } catch (_) {
    // Mixpanel must not silence Amplitude or change auth
  }
  try {
    tracking(eventName, properties, { mixpanel: false });
  } catch (_) {
    // Amplitude must not silence Mixpanel or change auth
  }
}

export function emitAuthRefreshFailed(props?: AuthTelemetryProps) {
  emitIsolated(AUTH_REFRESH_FAILED, sanitizeAuthTelemetryProps(props));
}

export function emitAuthSessionReset(props?: AuthTelemetryProps) {
  emitIsolated(AUTH_SESSION_RESET, sanitizeAuthTelemetryProps(props));
}
